import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export const useSubcategories = (categoryId = null) => {
  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubcategories = async () => {
      if (!categoryId) {
        setSubcategories([]);
        return;
      }

      try {
        setLoading(true);
        console.log('Fetching subcategories for category:', categoryId);

        const { data, error: fetchError } = await supabase
          .from('subcategories')
          .select('id, name_en, name_ar, slug, category_id, img')
          .eq('category_id', categoryId)
          .order('name_en', { ascending: true });

        if (fetchError) {
          console.error('Error fetching subcategories:', fetchError);
          throw fetchError;
        }

        if (data) {
          console.log(`Found ${data.length} subcategories for category ${categoryId}`);
          setSubcategories(data || []);
        } else {
          setSubcategories([]);
        }
      } catch (err) {
        console.error('Error fetching subcategories:', err);
        setError(err.message);
        setSubcategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSubcategories();
  }, [categoryId]);

  return { subcategories, loading, error };
};

// Hook to fetch all subcategories grouped by category
export const useAllSubcategories = () => {
  const [subcategoriesByCategory, setSubcategoriesByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllSubcategories = async () => {
      try {
        setLoading(true);
        console.log('Fetching all subcategories...');

        const { data, error: fetchError } = await supabase
          .from('subcategories')
          .select('id, name_en, name_ar, slug, category_id, img')
          .order('name_en', { ascending: true });

        if (fetchError) {
          console.error('Error fetching subcategories:', fetchError);
          throw fetchError;
        }

        if (data) {
          // Group subcategories by category_id
          const grouped = {};
          data.forEach(subcategory => {
            const categoryId = subcategory.category_id;
            if (!grouped[categoryId]) {
              grouped[categoryId] = [];
            }
            grouped[categoryId].push(subcategory);
          });

          console.log(`Found subcategories for ${Object.keys(grouped).length} categories`);
          console.log('Grouped subcategories:', grouped);
          console.log('Category IDs with subcategories:', Object.keys(grouped));
          console.log('Sample subcategory:', data[0]);
          setSubcategoriesByCategory(grouped);
        } else {
          console.log('No subcategories data returned');
          setSubcategoriesByCategory({});
        }
      } catch (err) {
        console.error('Error fetching subcategories:', err);
        setError(err.message);
        setSubcategoriesByCategory({});
      } finally {
        setLoading(false);
      }
    };

    fetchAllSubcategories();
  }, []);

  return { subcategoriesByCategory, loading, error };
};

